import React, { useEffect, useState } from "react";
import SidebarItem from "./sidebar-item";
import Sider from "antd/es/layout/Sider";
import Permission from "../general/permission/permission";
import { useLayout } from "../../context/layoutContext";
import { ReactComponent as Logo } from "../../assets/logo.svg";
import "./sidebar.scss";
import { Avatar, Divider, Popover } from "antd";
import { USER_TYPES_TEXT } from "../../constants/constants";
import useAuth from "../../hooks/useAuth";
import { downloadFile } from "../../services/files";
import lines from "../../assets/lines.svg";

function Sidebar({ items }: { items: any }) {
  const [openPopover, setOpenPopover] = useState(false);
  const [url, setUrl] = useState<string | undefined>("");
  const handleOpenChange = (newOpen: boolean) => {
    setOpenPopover(newOpen);
  };
  const { handleLogout, userData } = useAuth();

  const layout = useLayout();

  useEffect(() => {
    getUrl();
  }, []);

  const getUrl = async () => {
    const uri = await downloadFile(userData?.profilePicture, "image");
    setUrl(uri);
  };

  const onToggleSidebar = () => {
    layout.toggleSidebar();
  };

  return (
    <Sider
      width={300}
      collapsedWidth={90}
      collapsed={layout.isSidebarClosed}
      theme="light"
    >
      <div
        className={`${layout.isSidebarClosed ? "collapsed" : "open"} sidebar`}
      >
        <div
          className={"lines"}
          onClick={onToggleSidebar}
          style={layout.isSidebarClosed ? { marginBottom: "100px" } : {}}
        >
          <img src={lines} alt="lines" />
        </div>
        {!layout.isSidebarClosed && (
          <div className={"logo"}>
            <Logo />
          </div>
        )}

        <div className={"items"}>
          <ul>
            {items.map((item: any, index: number) => {
              const allowedPerms = item.permission ? [item.permission] : [];
              if (item.children) {
                item.children.forEach((c: any) => {
                  if (c.permission) allowedPerms.push(c.permission);
                });
              }

              return (
                <Permission
                  requiredPermissions={allowedPerms}
                  key={`sidebar-item-${index}`}
                >
                  <SidebarItem
                    icon={item.icon}
                    name={item.label}
                    key={item.key}
                    id={item.key}
                    subMenu={item.children}
                    path={item.path}
                  />
                </Permission>
              );
            })}
          </ul>

          <div className="user-profile-wrapper">
            <Divider />
            <div className={"group"}>
              <Popover
                content={<a onClick={handleLogout}>Cerrar sesión</a>}
                title={`${userData?.name}`}
                trigger="click"
                open={openPopover}
                onOpenChange={handleOpenChange}
              >
                <div className={"initials"}>
                  <Avatar
                    size={60}
                    icon={
                      url ? (
                        <img src={url} alt={userData?.name[0]} />
                      ) : (
                        <h4>
                          {(userData &&
                            userData.name &&
                            userData.name.length > 0 &&
                            userData.name[0]) ||
                            "N"}
                        </h4>
                      )
                    }
                  />
                </div>
              </Popover>
              {!layout.isSidebarClosed && (
                <div className={"user_info"}>
                  <p className={"name"}>{userData?.name}</p>
                  <p className={"role"}>
                    {USER_TYPES_TEXT[userData?.type || "client"]}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Sider>
  );
}

export default Sidebar;
